<h2 class="h2">Unsere Angebote im Überblick</h2>

<div class="tariffs">
  <app-swiper [options]="swiperOptions">
    @for (product of showcase; track product.product_id; let i = $index) {
      <swiper-slide>
        <app-tariff [product]="product" />
      </swiper-slide>
    }
  </app-swiper>
</div>
